import {
  SearchableResourceFilterInput,
  ContentFilter,
  LaunchOptions,
} from "@examspark/types";

export const buildSearchFilterFromLaunchOptions = (
  launchOptions: LaunchOptions<unknown> | undefined,
  baseFilter?: SearchableResourceFilterInput,
) => {
  const filter: SearchableResourceFilterInput = {
    and: [],
  };

  if (baseFilter) filter.and?.push(baseFilter);

  const tags = buildTagsSearchFilterFromContentFilter(
    launchOptions?.contentFilter,
  );
  if (tags.and?.length) {
    filter.and?.push(...tags.and);
  }

  return filter;
};

export const buildTagsSearchFilterFromContentFilter = (
  contentFilter: ContentFilter | undefined,
) => {
  const filter: SearchableResourceFilterInput = {
    and: [],
  };

  if (!contentFilter) return filter;

  if (contentFilter.tags?.include) {
    for (const tag of contentFilter.tags.include) {
      if (tag.key && tag.type && tag.value) {
        filter.and?.push({
          tags: {
            eq: `${tag.key}#${tag.value}`,
          },
        });
      }
    }
  }

  if (contentFilter.tags?.or) {
    const orConditions: SearchableResourceFilterInput[] = [];
    for (const tag of contentFilter.tags.or) {
      orConditions.push({
        and: tag.include?.map((t) => ({
          tags: {
            eq: `${t.key}#${t.value}`,
          },
        })),
      });
    }
    filter.and?.push({ or: orConditions });
  }

  return filter;
};
